"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("../styles");
const styles = styles_1.createStyles(({ palette }) => ({
    '@keyframes blink': {
        '0%': {
            opacity: 0.3,
            color: palette.secondary,
        },
        '50%': {
            opacity: 1,
            color: palette.primary,
        },
        '100%': {
            opacity: 0.3,
            color: palette.secondary,
        },
    },
    loadingContainer: {
        animationName: '$blink',
        animationDuration: '1s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'ease-in-out',
    },
}));
exports.decorate = styles_1.withStyles(styles);
